<main class="fadeIn">
  <div class="container-fluid" #focusedElement>
      <div class="row">
          <div class="col-12">
              <div class="header d-flex justify-content-between">
                  <h1><small>&nbsp;</small>Rule Configurations</h1>
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-12">
              <div class="filter-body">
                  <div class="filter">
                      <div class="row justify-content-between">
                          <div class="col-10">
                              <div class="row" [formGroup]="filterationForm">
                                  <div class="col-3">
                                      <app-datepicker_v2 formControlName="validity" [field]="feild_startDate"
                                          [disabled]="isAddPage">
                                      </app-datepicker_v2>
                                  </div>
                                  <div class="col-3">
                                      <input type="text" class="form-control " formControlName="version"
                                          id="searchVersion" placeholder="Search by version">
                                  </div>
                                  <div class="col-1">
                                      <input autocomplete="disabled" class="form-check-input" formControlName="inUse"
                                          type="checkbox" id="inUse" name="inUse">
                                      <label class="form-check-label link" for="inUse">In Use</label>
                                  </div>
                                  <div class="col-2 d-flex">
                                      <button id="btnDrugFilterApply" type="button" (click)="onApply()"
                                          class="btn btn-dark-blue">APPLY</button>
                                      <a class="reset-btn" (click)="onReset()"><span></span>Reset</a>
                                  </div>
                              </div>

                          </div>
                          <div class="col-2"
                              *ngIf="checkPermission('editRuleConfigVersion')">
                              <button id="btnGroupAddNewDrugList" type="button" data-bs-toggle="modal"
                                  class="btn btn-primary float-end" (click)="configurationAdd()">
                                  ADD New
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-12">
              <div class="table-container table-responsive">
                  <table class="table table-list" *ngIf="ruleConfigList?.length">
                      <caption class="d-none">Preferref drug list table body</caption>
                      <thead>
                          <tr>
                              <th scope="col" class="text-left">Version
                                  <span *ngIf="ruleConfigList?.length" class="sort-order"
                                      (click)="sortColumn('version')">
                                      <a class="{{columnSort['version'].sortType}} "></a>
                                  </span>
                              </th>
                              <th scope="col" class="text-left">Validity
                                  <span *ngIf="ruleConfigList?.length" class="sort-order"
                                      (click)="sortColumn('activeFrom')">
                                      <a class="{{columnSort['activeFrom'].sortType}} "></a>
                                  </span>
                              </th>

                              <th scope="col">Actions
                              </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr *ngFor="let ruleConfig of ruleConfigList">
                              <td>{{ruleConfig?.ruleConfigurationVersion }}</td>
                              <td>{{ruleConfig?.activeFrom | dateFormat}} - {{ruleConfig?.expiredOn |
                                  date:'dd/MM/yyyy'}}</td>
                              <td>
                                  <ul class="actions">
                                      <li *ngIf="checkPermission('editRuleConfigVersion')">
                                          <a id="RuleCNEdit" data-bs-toggle="modal"
                                              (click)="configurationEdit(ruleConfig)"
                                              class="edit-icon tool-wrap position-relative">
                                              <div class="custom-tooltip tooltip-top" role="tooltip">
                                                  <div class="arrow"></div>
                                                  <div class="tooltip-inner"> Edit </div>
                                              </div>
                                          </a>
                                      </li>
                                      <li >
                                          <a id="RuleCNView" data-bs-toggle="modal"
                                              (click)="configurationDetails(ruleConfig)"
                                              class="view tool-wrap position-relative">
                                              <div class="custom-tooltip tooltip-top" role="tooltip">
                                                  <div class="arrow"></div>
                                                  <div class="tooltip-inner"> View </div>
                                              </div>
                                          </a>
                                      </li>
                                  </ul>
                              </td>
                          </tr>
                      </tbody>
                  </table>
                  <div class="no-data with-border" *ngIf="!ruleConfigList?.length">
                      <img src="./assets/images/icons/no-data-img.svg" alt="">
                      <p>No Results Found</p>

                  </div>
              </div>
              <app-navigation *ngIf="!showNavigation" [class.d-none]="!ruleConfigList?.length"
                  [listLength]="totalCount" [pageNo]="page_no" (currentPageDetail)="currentPageDetail($event)" >
              </app-navigation>
          </div>
      </div>
  </div>
</main>
<app-rule-configuration-edit *ngIf="showConfigurationEdit" [selectedConfig]="selectedConfig" (close)="showConfigurationEdit = false; onReset();isAddPage=false;"   [isAddPage]="isAddPage" [systemConfigEdit]="systemConfigEdit">
</app-rule-configuration-edit>
<app-rule-configuration-details *ngIf="showConfigurationDetails" [selectedConfig]="selectedConfig" (close)="showConfigurationDetails = false" (editPage)="manageEdit()" (selectedItem)="selectedConfig" [systemConfigView]="true">
</app-rule-configuration-details>
